import SidebarMenuItem from "./SideBarMenuItem"
import SidebarSubMenu from "./SideBarSubMenu"

export const SidebarMenuRecursive = ({ item }: any) => {
  return item?.child?.length ? (
    <SidebarSubMenu key={item.key} item={item} />
  ) : (
    <SidebarMenuItem key={item.key} item={item} />
  )
}
